<template>
  <!-- 区域下的监控列表 -->
  <div class="page_box">
    <div class="page_option_box">
      <!-- 监控列表 -->
      <el-page-header
        @back="$Common.pageJump('/regional_management', 3)"
        content="区域监控列表"
      >
      </el-page-header>
      <div class="search_box">
        <el-button
          type="primary"
          plain
          size="mini"
          icon="el-icon-circle-plus-outline"
          @click="getNotBindingMonitorList()"
          >添加监控</el-button
        >
        <el-select
          v-model="requestData.monitorAreaId"
          size="mini"
          style="margin-left:10px"
        >
          <el-option
            v-for="(value, key) in monitorAreaList"
            :key="key"
            :value="value.id + ''"
            :label="value.areaName"
          >
            {{ value.areaName }}
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          v-loading="tableLoading"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
        >
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="monitorName"
            label="监控通道名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="monitorChannel"
            label="监控通道号"
            width="100"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="deviceNum"
            label="设备编号"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="监控状态"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.status == 0">启用</el-tag>
              <el-tag type="danger" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" align="center" width="200">
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="rowData">
                <el-link
                  class="link_box"
                  type="primary"
                  :underline="false"
                  @click="bindingOrUnbindMonitorArea(rowData.row.monitorId, 2)"
                  >取消绑定</el-link
                >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 未绑定的监控摄像头 -->
    <el-dialog
      title="未绑定的监控摄像头"
      :visible.sync="notBindingMonitorBox"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
      width="40%"
    >
      <div class="dialog_box">
        <el-table
          :data="notBindingMonitorList"
          height="500px"
          class="dialog_table_box"
        >
          <el-table-column label="序号" width="70" align="center" type="index">
          </el-table-column>
          <el-table-column
            prop="monitorName"
            label="监控通道名称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="监控状态"
            width="80"
            align="center"
          >
            <template v-slot="scope">
              <el-tag type="warning" v-if="scope.row.status == 0">启用</el-tag>
              <el-tag type="danger" v-else>禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-button
                type="primary"
                plain
                size="mini"
                @click="bindingOrUnbindMonitorArea(scope.row.monitorId, 1)"
                >绑定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      requestData: {
        schoolId: this.$store.state.schoolId,
        monitorAreaId: sessionStorage.getItem("selectedMonitorRegion")
      },
      tableData: [],
      notBindingMonitorList: [],
      notBindingMonitorBox: false,
      // 监控区域列表
      monitorAreaList: [],
      tableLoading: false
    };
  },
  watch: {
    "requestData.monitorAreaId": {
      handler() {
        this.getMonitorList();
        sessionStorage.setItem(
          "selectedMonitorRegion",
          this.requestData.monitorAreaId
        );
      }
    }
  },
  computed: {},
  methods: {
    // 获取监控区域
    async getMonitoringArea() {
      var newParamData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getMonitoringArea(newParamData);
      if (res.code == 200) {
        this.monitorAreaList = res.data;
        // console.log(this.monitorAreaList)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 绑定 / 取消绑定 区域
    async bindingOrUnbindMonitorArea(id, cate = 1) {
      var newParamData = {
        monitorId: id,
        monitorAreaId: this.requestData.monitorAreaId
      };
      if (cate == 2) {
        var newParamData = {
          monitorId: id
        };
      }
      let res = await this.$Http.bindingOrUnbindMonitorArea(newParamData);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.getMonitorList();
        if (cate == 1) {
          this.getNotBindingMonitorList();
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取监控列表
    async getMonitorList() {
      this.tableLoading = true;
      var newParamData = this.requestData;
      let res = await this.$Http.getMonitorList(newParamData);
      this.tableLoading = false;
      if (res.code == 200) {
        let data = res.data || [];
        this.tableData = data.map((item, index) => {
          item.isEdit = false;
          return item;
        });
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.tableData = [];
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    // 获取未绑定监控列表
    async getNotBindingMonitorList() {
      var newParamData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getNotBindingMonitorList(newParamData);
      if (res.code == 200) {
        this.notBindingMonitorList = res.data;
        this.notBindingMonitorBox = true;
        // console.log(this.notBindingMonitorList)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  },
  created() {},
  mounted() {
    this.getMonitoringArea();
    this.getMonitorList();
  }
};
</script>
<style scoped></style>
